import { Route, Routes } from 'react-router-dom'
import Home from './components/Home'
import About from './components/About'
import Contact from './components/Contact'
import Layout from './components/Layout'
import Portfolio from './components/Portfolio'
// import Dashboard from './components/Dashboard';
import NewPortfolio from './components/NewPortfolio'
import NotFoundPage from './pages/NotFoundPage'

import './App.scss'

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="portfolio" element={<Portfolio />} />
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          {/* <Route path="/new-portfolio" element={<NewPortfolio />} /> */}
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  )
}

export default App
